import React from 'react';
import { Svelte } from '../utils/SvelteToReact';
import { ComboTextField as ComboTextFieldSvelte } from '@glance-design/combo-text-field';

export const ComboTextField = (props) => {
  const defineProps = {
    size: props.size,
    label: props.label,
    shape: props.shape,
    placeholder: props.placeholder,
    error: props.error || false,
    errorMessage: props.errorMessage,
    warn: props.warn || false,
    warnMessage: props.warnMessage,
    helpMessage: props.helpMessage,
    disabled: props.disabled || false,
    required: props.required || false,
    type: props.type,
    id: props.id,
    name: props.name,
    onChange: props.onChange,
    onInput: props.onChange,
    slotIconLeft: props.slotIconLeft,
    slotAction: props.slotAction
  };

  const className = props.class ? props.class : "comboTextField";

  return (
    <div className={"[&_input]:!min-w-full "+className} id="comboTextField">
      <Svelte
        component={ComboTextFieldSvelte}
        {...defineProps}
        createSlotContainer={name => {
          // Custom slot element to inherit the size of the parent
          if (name === 'iconLeft') {
            const slot = document.createElement('span');
            slot.className = 'w-[inherit] h-[inherit]';
            return slot;
          }

          return document.createElement('div')
        }}
      ></Svelte>
    </div>
  );
};
